import { useNavigate } from '@tanstack/react-router'
import { Table, Typography } from 'antd'
import React from 'react'
import { UsePaginationTableProps } from '../../hooks/use-pagination'
import { TimeAgo } from '../../components/time-ago'
import { Company } from '../company'
import { useTranslation } from 'react-i18next'

export function CompanyTable({ withColumnDefaults, ...props }: UsePaginationTableProps<Company>) {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <Table
            size="small"
            {...props}
            rowClassName="cursor-pointer"
            scroll={{
                x: 800,
                y: 800,
            }}
            onRow={(record) => {
                return {
                    onClick: () => {
                        navigate({
                            to: '/companies/$companyId',
                            params: { companyId: record.id },
                        })
                    },
                }
            }}
            columns={withColumnDefaults([
                {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name',
                    sorter: true,
                },
                {
                    title: t('Users'),
                    dataIndex: 'usersCount',
                    key: 'usersCount',
                    width: 120,
                    sorter: true,
                    render(usersCount) {
                        return <Typography.Text>{usersCount ?? 0}</Typography.Text>
                    },
                },
                {
                    title: t('Campaigns'),
                    dataIndex: 'campaignsCount',
                    key: 'campaignsCount',
                    width: 130,
                    sorter: true,
                    render(campaignsCount) {
                        return <Typography.Text>{campaignsCount ?? 0}</Typography.Text>
                    },
                },
                {
                    title: t('Candidates'),
                    dataIndex: 'candidatesCount',
                    key: 'candidatesCount',
                    width: 120,
                    sorter: true,
                    render(candidatesCount) {
                        return <Typography.Text>{candidatesCount ?? 0}</Typography.Text>
                    },
                },
                {
                    title: t('Tier'),
                    dataIndex: 'tier',
                    key: 'tier',
                    width: 200,
                    sorter: true,
                    render(tier, record) {
                        return (
                            <Typography.Text>
                                {tier ? `${t(`tier.${tier}`)} - ${t(`period.${record.period}`)}` : '-'}
                            </Typography.Text>
                        )
                    },
                },
                {
                    title: t('Created'),
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    width: 180,
                    sorter: true,
                    render(date) {
                        return <TimeAgo date={date} />
                    },
                },
            ])}
        />
    )
}
